export type IInitLogoutTimer = IDCA.IGenericFunc;

export function initLogoutTimer() {
  const { userOptions } = window.DexeroCoreApp;
  const { sessionTimeout, langObj = {} } = userOptions;
  const { sessionExpiringTitleText, sessionExpiringBodyText } = langObj;

  const $button = $('.logout-button').first();
  const $timer = $button.find('.logout-timer');
  if (!$button.length || !$timer.length || !sessionTimeout) {
    return;
  }
  let now;
  let reloadAt;
  let difference: number;
  let countdownTimer: any;
  let popupOpen: boolean;

  $button.data({
    'timer-end': reloadAt,
    'timer-start': now,
  });

  function coutdown() {
    const hours = Math.floor(Math.floor(difference / 1000) / 60 / 60);

    const minutes = Math.floor(Math.floor(difference / 1000) / 60);
    const mins = minutes - Math.floor(hours * 60);

    const seconds = Math.floor(Math.floor(difference / 1000));
    const secs = seconds - Math.floor(minutes * 60);

    const minsDisplay = mins.toString().length === 1 ? `0${mins}` : mins;
    const secsDisplay = secs.toString().length === 1 ? `0${secs}` : secs;
    const refreshTime = ` ${hours === 0 ? '' : `${hours}:`}${minsDisplay}:${secsDisplay}`;

    $timer.text(refreshTime);

    difference -= 1000;
    if (difference < 30000 && !popupOpen) {
      popupOpen = true;
      window.DexeroCoreApp.confirmUserAction(
        'question',
        sessionExpiringTitleText,
        sessionExpiringBodyText,
        undefined,
        30000
      )
        .done(() => startSession(true))
        .fail(() => logout());
    }
  }

  function logout() {
    const href = $button.attr('href') || '';
    window.DexeroCoreApp.redirectToPage(href);
  }

  function startSession(reset?: boolean) {
    if (reset) {
      // Reset session
      const href = `${window.location.href}${window.DexeroCoreApp.getUrlSeperator(
        window.location.href
      )}ajax=true&json=true`;
      $.get(href);
      popupOpen = false;
    }

    now = window.moment();
    reloadAt = now.clone().add(sessionTimeout, 'ms');
    difference = reloadAt.diff(now);
    clearInterval(countdownTimer);
    countdownTimer = setInterval(coutdown, 1000);
  }

  startSession(true);
  window.DexeroCoreApp.subscribe('/sessionUser/restart/', () => {
    startSession(true);
  });
}
